<template>

    <div class="row mb-5 justify-content-md-center">
        <div class="col-md-6">
            <div class="d-inline-block mb-3">
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelected">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
                <button type="button" class="btn btn-primary ms-2" @click="getData(yearSelected)"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2"/>Cari</button>
            </div>
            <button type="button" class="btn btn-warning ms-2 float-end"
                    @click="goBack">
                <font-awesome-icon :icon="faChevronLeft" /> Kembali
            </button>
            <form v-if="pewakafPGW.length > 0" :action="uri_download_report_pgw" method="post">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="month" :value="yearSelected">
                <button type="submit" class="btn btn-outline-success mb-3 fs-6" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
            </form>
            <table v-if="pewakafPGW.length > 0" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col" class="text-center">#</th>
                    <th>Bulan</th>
                    <th>Bilangan</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in pewakafPGW">
                    <tr>
                        <th scope="row" class="text-center">{{index+1}}</th>
                        <td>{{ item.bulanPrimitive}}</td>
                        <td>{{ sumFormatWithoutDecimal(item.bilangan)}}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onBeforeMount, onMounted, ref} from "vue";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import {sumFormatWithoutDecimal} from "../../utils/utils";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
library.add(faChevronLeft);
library.add(faFileExcel);
library.add(faMagnifyingGlass);

const data = defineProps<{
    uri_get_pgw: string,
    csrf: string,
    year: number,
    uri_download_report_pgw: string,
}>();
const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();

const pewakafPGW = ref<{
    bulan: number,
    bulanPrimitive: string,
    bilangan: number,
}[]>([]);
const yearRange = ref<number[]>([]);
const yearSelected = ref<number>();

let getData = (tahun : number | null = null) =>{
    emitToParent("showLoader");
    pewakafPGW.value = [];
    axios({
        method: "post",
        url: data.uri_get_pgw,
        data:{
            csrf: data.csrf,
            year: tahun
        },
        headers: {"Content-Type": "application/json"}
    }).then(function (response) {
        pewakafPGW.value = response.data;
        emitToParent("hideLoader");
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk hantar" + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

let initDateData = () =>{
    for(let y = data.year; y >= 2015; y--){
        yearRange.value.push(y);
    }
}

let goBack = (): void => {
    emitToParent("hidePage", true);
}


onBeforeMount(()=>{
    getData();
    initDateData();
});

onMounted(()=>{
    yearSelected.value = data.year;
})

</script>
<style scoped>

</style>
